export const CBLCols = [{ 
    headerClassName: 'data-table header fixedNumber',
    className: 'fixedNumber',
    show: true,
    accessor: 'cblNumber',
    isActionLink: true,
    id: 'cblNumber-col-link',
    fieldHeader: 'CBL number',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'productType',
    id: 'productType-col',
    fieldHeader: 'Product Type',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'status',
    id: 'status-col',
    fieldHeader: 'Status',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'carrierCode',
    id: 'carrier-col',
    fieldHeader: 'Carrier Code',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'carrierBookingReference',
    id: 'carrierBooking-col',
    fieldHeader: 'Carrier Booking Reference',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'loadingPortCode',
    id: 'loadingPortCode-col',
    fieldHeader: 'Port of Loading',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'dischargePortCode',
    id: 'dischargePortCode-col',
    fieldHeader: 'Port of Discharge',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'consigneeBusinessEntityCode',
    id: 'consignee-col',
    fieldHeader: 'Consignee',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'shipperBusinessEntityCode',
    id: 'shipper-col',
    fieldHeader: 'Shipper',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'etdDate',
    id: 'etd-col',
    fieldHeader: 'ETD',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'etaDate',
    id: 'eta-col',
    fieldHeader: 'ETA',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'lastChangedBy',
    id: 'lastChangedBy-col',
    fieldHeader: 'Last Changed By',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'lastChangedDate',
    id: 'lastChangeDate-col',
    fieldHeader: 'Last Change Date',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'id',
    id: 'CBL-ID-col',
    fieldHeader: 'CBL ID',
    sortable: false 
}]